// extracted by mini-css-extract-plugin
module.exports = {"blog_landing_category":"styles_blog_landing_category__MFL9c","blog_landing_view_all":"styles_blog_landing_view_all__VAskL","category_title":"styles_category_title__vcUwC"};